import axios from "axios";
import Globais, { validateToken } from "../components/Globais";
import { PeriodosProximosDoisAnosResumo } from "../interfaces/PeriodosProximosDoisAnosResumo";

export const buscarPeriodosProximosDoisAnosService = async () => {
  const token = validateToken();

  if (!token) {
    return null;
  }

  const url = `${Globais.DOMINIOBACK}/empreendimento/dashboard/origem-zero/cronograma-fixo/periodos-proximos-dois-anos`;
  const response = await axios.get<PeriodosProximosDoisAnosResumo>(url, {
    headers: { Authorization: token.AuthStr },
  });

  return response.data;
};
